import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue')
  },
  // 服务商管理
  {
    path: '/service-provider/list',
    name: 'ServiceProviderList',
    component: () => import('@/views/serviceProvider/ServiceProviderList.vue')
  },
  {
    path: '/service-provider/mini-app',
    name: 'MiniAppList',
    component: () => import('@/views/serviceProvider/MiniAppList.vue')
  },
  {
    path: '/service-provider/admin',
    name: 'PlatformAdminList',
    component: () => import('@/views/serviceProvider/AdminList.vue')
  },
  // 店铺管理
  {
    path: '/shop/list',
    name: 'ShopList',
    component: () => import('@/views/shop/ShopList.vue')
  },
  {
    path: '/shop/admins',
    name: 'ShopAdminList',
    component: () => import('@/views/shop/AdminList.vue')
  },
  // 商品管理
  {
    path: '/goods/list',
    name: 'GoodsList',
    component: () => import('@/views/goods/GoodsList.vue')
  },
  {
    path: '/goods/hot',
    name: 'HotGoods',
    component: () => import('@/views/goods/HotGoods.vue')
  },
  // 订单管理
  {
    path: '/order/list',
    name: 'OrderList',
    component: () => import('@/views/order/OrderList.vue')
  },
  {
    path: '/order/detail/:id',
    name: 'OrderDetail',
    component: () => import('@/views/order/OrderDetail.vue')
  },
  {
    path: '/order/rent-bills',
    name: 'RentBillList',
    component: () => import('@/views/order/RentBillList.vue')
  },
  {
    path: '/order/rent-settlement',
    name: 'RentSettlement',
    component: () => import('@/views/order/RentSettlement.vue')
  },
  {
    path: '/order/compensation',
    name: 'CompensationList',
    component: () => import('@/views/order/CompensationList.vue')
  },
  // 内容管理
  {
    path: '/banner/list',
    name: 'BannerList',
    component: () => import('@/views/banner/BannerList.vue')
  },
  {
    path: '/category/list',
    name: 'CategoryList',
    component: () => import('@/views/category/CategoryList.vue')
  },
  // 小程序管理
  {
    path: '/mini-app/list',
    name: 'MiniAppList',
    component: () => import('@/views/serviceProvider/MiniAppList.vue')
  },
  {
    path: '/mini-app/admin',
    name: 'MiniAppAdminList',
    component: () => import('@/views/serviceProvider/AdminList.vue')
  },
  // 管理员管理
  {
    path: '/admin/list',
    name: 'AdminList',
    component: () => import('@/views/admin/AdminList.vue')
  },
  // 用户管理
  {
    path: '/user/list',
    name: 'UserList',
    component: () => import('@/views/user/UserList.vue')
  }
]

const router = new Router({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (to.meta.noAuth) {
    next()
    return
  }
  if (!token) {
    next('/login')
    return
  }
  next()
})

export default router
